module.exports = __webpack_public_path__ + "static/media/nossa-senhora-aparecida.f2eef851.png";